import React from 'react';
import { useTranslation } from 'react-i18next';
import stravaConnectButton from '../assets/strava/btn_strava_connect_with_orange.svg';
import poweredByStrava from '../assets/strava/api_logo_pwrdBy_strava_horiz_orange.svg';

// Step 1 of "How it works" across /maps, /invite, /event and /challenge. Logged out, the
// whole card is the Strava connect button people already try to click. Signed in there is
// nothing to connect, so the button graphic gives way to the attribution logo and the card
// goes inert rather than sitting there as a dead control.
function HowItWorksConnectCard({ user, onConnect, title, desc }) {
  const { t } = useTranslation();

  const body = (
    <>
      <div className="hiw-visual hiw-visual-connect">
        {user ? (
          <img src={poweredByStrava} alt="Powered by Strava" className="hiw-strava-logo" />
        ) : (
          <img src={stravaConnectButton} alt="" className="hiw-strava-btn" />
        )}
      </div>
      <div className="hiw-content">
        <div className="hiw-badge">1</div>
        <h3>{title || t('mapGenPage.hiw1Title', 'Connect Strava')}</h3>
        <p>{desc || t('mapGenPage.hiw1Desc', 'One tap. We never touch your activity data beyond reading the route.')}</p>
      </div>
    </>
  );

  if (user) {
    return <div className="hiw-card">{body}</div>;
  }

  return (
    <button
      type="button"
      className="hiw-card hiw-card-action"
      onClick={onConnect}
      aria-label={t('mapGenPage.hiw1Cta', 'Connect with Strava')}
    >
      {body}
    </button>
  );
}

export default HowItWorksConnectCard;
